 // Detectar si la URL contiene "stage" ó "localhost"
 const baseURL = window.location.href.includes("stage") || window.location.href.includes("localhost") || window.location.href.includes("dev")
 ? "https://static.stage.spradling.group"
 : "https://static.spradling.group";

export const STATIC_SPRADLING_DOMAIN = baseURL
